import React from 'react';

import { is, validatePassword } from '../../utils';
import { useAppContext } from '../../hooks';

import Form from '../Form';
import FormField from '../FormField';
import FormFooter from '../FormFooter';
import PasswordCheck from '../PasswordCheck';

import PasswordResetLayout from './PasswordResetLayout';

function PasswordResetForm() {
  const { config } = useAppContext();
  if (!config.is_valid_link) {
    return (
      <PasswordResetLayout error>
        <div
          dangerouslySetInnerHTML={{
            __html: i18n.gettext(
              'This reset link is invalid, possibly because it has already been used. Please <a href="/password/reset">request a new reset</a>.'
            ),
          }}
        />
      </PasswordResetLayout>
    );
  }
  return (
    <PasswordResetLayout>
      <Form
        initialValues={{
          new_password1: '',
          new_password2: '',
        }}
        validate={({ new_password1, new_password2 }) => {
          const errors = {};
          const { isValid, ...validationErrors } =
            validatePassword(new_password1);
          if (!isValid) {
            errors.new_password1 = validationErrors;
          }
          if (is.empty(new_password2)) {
            errors.new_password2 = i18n.gettext(
              'Please confirm the new password.'
            );
          } else if (new_password1 !== new_password2) {
            errors.new_password2 = i18n.gettext(
              "The two passwords don't match."
            );
          }
          return errors;
        }}
      >
        <FormField
          type="password"
          name="new_password1"
          autoComplete="new-password"
          label={i18n.gettext('New password')}
        />
        <FormField
          type="password"
          name="new_password2"
          autoComplete="new-password"
          label={i18n.gettext('Confirm password')}
        />
        <PasswordCheck fieldName="new_password1" />
        <FormFooter submitButtonLabel={i18n.gettext('Change password')} />
      </Form>
    </PasswordResetLayout>
  );
}

export default PasswordResetForm;
